(function () {
  var videoButtons = document.querySelectorAll('.fo-video__button');

  videoButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      button.blur();
    });
  });

  function syncHashScrollOffset() {
    var header = document.querySelector('.fo-face-header');
    if (!header) {
      return;
    }

    var position = window.getComputedStyle(header).position;
    if (position !== 'fixed' && position !== 'sticky') {
      document.documentElement.style.scrollPaddingTop = '0px';
      return;
    }

    var inner = header.querySelector('.fo-face-header-inner');
    var headerHeight = header.getBoundingClientRect().height;
    var barHeight = inner ? inner.getBoundingClientRect().height : headerHeight;
    var offset = Math.round(Math.min(headerHeight, barHeight));

    document.documentElement.style.scrollPaddingTop = offset + 'px';
  }

  function closeHeaderMenu() {
    document.body.classList.remove('active-menu');
    syncHashScrollOffset();
  }

  syncHashScrollOffset();
  window.addEventListener('resize', syncHashScrollOffset);

  document.querySelectorAll('.fo-face-header-explore').forEach(function (exploreButton) {
    exploreButton.addEventListener('click', function () {
      document.body.classList.add('active-menu');
    });
  });

  document.querySelectorAll('.fo-face-header__dropdown-close').forEach(function (closeButton) {
    closeButton.addEventListener('click', closeHeaderMenu);
  });

  document.querySelectorAll('.fo-face-header__dropdown-overlay').forEach(function (overlay) {
    overlay.addEventListener('click', closeHeaderMenu);
  });

  document.querySelectorAll('.fo-face-header__dropdown nav a').forEach(function (link) {
    link.addEventListener('click', closeHeaderMenu);
  });

  document.querySelectorAll('[data-fo-menu]').forEach(function (menuButton) {
    var nav = document.getElementById(menuButton.getAttribute('aria-controls'));

    if (!nav) {
      return;
    }

    function closeMenu() {
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Open navigation');
      nav.classList.remove('is-open');
    }

    menuButton.addEventListener('click', function () {
      var willOpen = menuButton.getAttribute('aria-expanded') !== 'true';

      menuButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      menuButton.setAttribute('aria-label', willOpen ? 'Close navigation' : 'Open navigation');
      nav.classList.toggle('is-open', willOpen);
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('click', function (event) {
      if (menuButton.getAttribute('aria-expanded') !== 'true') {
        return;
      }

      if (!nav.contains(event.target) && !menuButton.contains(event.target)) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') {
        closeMenu();
        menuButton.focus();
      }
    });
  });

  document.querySelectorAll('[data-fo-faq]').forEach(function (faqRoot) {
    faqRoot.querySelectorAll('[data-fo-faq-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.fo-faq__item');
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        var willOpen = button.getAttribute('aria-expanded') !== 'true';

        if (!item || !panel) {
          return;
        }

        faqRoot.querySelectorAll('.fo-faq__item').forEach(function (otherItem) {
          var otherButton = otherItem.querySelector('[data-fo-faq-toggle]');
          var otherPanel = otherButton && document.getElementById(otherButton.getAttribute('aria-controls'));
          var isCurrent = otherItem === item && willOpen;

          otherItem.classList.toggle('is-open', isCurrent);
          if (otherButton) {
            otherButton.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');
          }
          if (otherPanel) {
            otherPanel.hidden = !isCurrent;
          }
        });
      });
    });
  });

  document.querySelectorAll('.fo-face-list.hoverable').forEach(function (list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('article'));

    if (!items.length) {
      return;
    }

    function setActive(target) {
      var next = null;

      if (target && items.indexOf(target) !== -1) {
        next = target;
      } else {
        items.some(function (item) {
          if (item.classList.contains('active')) {
            next = item;
            return true;
          }
          return false;
        });
        if (!next) {
          next = items[items];
        }
      }

      items.forEach(function (item) {
        var isActive = item === next;
        var button = item.querySelector('[data-fo-design-tab]');

        item.classList.toggle('active', isActive);
        if (button) {
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        setActive(item);
      });
      item.addEventListener('click', function () {
        setActive(item);
      });
    });

    setActive();
  });

  document.querySelectorAll('[data-fo-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-fo-carousel-track]');
    var previous = carousel.querySelector('[data-fo-carousel-prev]');
    var next = carousel.querySelector('[data-fo-carousel-next]');
    var progressItems = carousel.querySelectorAll('.fo-carousel-progress i');

    if (!track) {
      return;
    }

    function scrollByCard(direction) {
      var card = track.firstElementChild;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      track.scrollBy({
        left: direction * distance,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    function updateControls() {
      var card = track.firstElementChild;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var currentIndex = distance ? Math.round(track.scrollLeft / distance) : 0;

      if (previous) {
        previous.disabled = track.scrollLeft <= 1;
      }
      if (next) {
        next.disabled = track.scrollLeft >= maxScroll - 1;
      }

      progressItems.forEach(function (item, index) {
        item.classList.toggle('is-active', index === currentIndex);
      });
    }

    if (previous) {
      previous.addEventListener('click', function () {
        scrollByCard(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollByCard(1);
      });
    }

    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  });

  document.querySelectorAll('[data-fo-buy-gallery]').forEach(function (gallery) {
    var stage = gallery.querySelector('[data-fo-buy-stage]');
    var thumbs = gallery.querySelectorAll('[data-fo-buy-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-fo-buy-src');
        var alt = thumb.getAttribute('data-fo-buy-alt');

        if (stage && src) {
          stage.src = src;
          if (alt) {
            stage.alt = alt;
          }
        }

        thumbs.forEach(function (other) {
          other.setAttribute('aria-pressed', other === thumb ? 'true' : 'false');
        });
      });
    });
  });
})();
